import React, { useState } from 'react';
import './ContactModal.scss';

const ContactModal = ({ isOpen, onClose }) => {
	const [contactForm, setContactForm] = useState({
		name: '',
		email: '',
		message: '',
	});

	const handleInputChange = e => {
		const { name, value } = e.target;
		setContactForm(prev => ({ ...prev, [name]: value }));
	};

	const handleContactSubmit = e => {
		e.preventDefault();
		// Create mailto link with form data
		const subject = encodeURIComponent(
			`Contact from ${contactForm.name} - Resume Website`
		);
		const body = encodeURIComponent(
			`Name: ${contactForm.name}\nEmail: ${contactForm.email}\n\nMessage:\n${contactForm.message}`
		);
		const mailtoLink = `mailto:jboutin@rockdown.net?subject=${subject}&body=${body}`;

		// Open mailto link
		window.location.href = mailtoLink;

		// Close modal and reset form
		onClose();
		setContactForm({ name: '', email: '', message: '' });
	};

	if (!isOpen) return null;

	return (
		<div className="contact-modal">
			<div className="contact-modal__overlay" onClick={onClose}>
				<div
					className="contact-modal__content"
					onClick={e => e.stopPropagation()}
				>
					<div className="contact-modal__header">
						<h3 className="contact-modal__title">Contact Me</h3>
						<button
							onClick={onClose}
							className="contact-modal__close"
						>
							×
						</button>
					</div>

					<form
						className="contact-modal__form"
						onSubmit={handleContactSubmit}
					>
						<div className="contact-modal__field">
							<label className="contact-modal__label">
								Name *
							</label>
							<input
								type="text"
								name="name"
								value={contactForm.name}
								onChange={handleInputChange}
								className="contact-modal__input"
								placeholder="Your name"
								required
							/>
						</div>

						<div className="contact-modal__field">
							<label className="contact-modal__label">
								Email *
							</label>
							<input
								type="email"
								name="email"
								value={contactForm.email}
								onChange={handleInputChange}
								className="contact-modal__input"
								placeholder="your.email@example.com"
								required
							/>
						</div>

						<div className="contact-modal__field">
							<label className="contact-modal__label">
								Message *
							</label>
							<textarea
								name="message"
								value={contactForm.message}
								onChange={handleInputChange}
								rows={4}
								className="contact-modal__textarea"
								placeholder="Your message..."
								required
							/>
						</div>

						<div className="contact-modal__actions">
							<button
								type="submit"
								className="contact-modal__button contact-modal__button--primary"
							>
								Send Message
							</button>
							<button
								type="button"
								onClick={onClose}
								className="contact-modal__button contact-modal__button--secondary"
							>
								Cancel
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

export default ContactModal;
